import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, FormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Observable, Subject, switchMap, take, takeUntil } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnInit {
  resetCode: string;
  working: boolean = false;
  complete: boolean = false;
  hasError: boolean = false;
  form: FormGroup;


  private $destroy = new Subject<void>();

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private fb: FormBuilder, private authService: AuthService) {
    this.form = this.fb.group({
      email: new FormControl<string>('', { validators: [Validators.required] }),
      newPassword: new FormControl<string>('', { validators: [Validators.required] }),
      confirmNewPassword: new FormControl<string>('', { validators: [Validators.required] })
    }, { validators: [this.confirmPasswordValidator] });
  }

  ngOnInit() {
    this.activatedRoute.queryParamMap
      .pipe(takeUntil(this.$destroy))
      .subscribe(pm => {
        if (pm.has('rc')) {
          this.resetCode = pm.get('rc')
        }
        else {
          this.router.navigateByUrl('/login');
        }
      })
  }

  get formControl() {
    return this.form.controls;
  }

  confirmPasswordValidator = (control: AbstractControl): ValidationErrors | null => {
    return control.value.newPassword === control.value.confirmNewPassword ? null : { PasswordNoMatch: true };
  };

  submit() {
    let val = this.form.value;

    if (this.form.valid) {
      this.working = true;
      this.hasError = false;

      this.authService.resetPasswordWithCode(val.email, val.newPassword, this.resetCode)
        .subscribe({
          next: () => {
            this.working = false;
            this.complete = true;
          },
          error: (err) => {
            this.working = false;
            this.hasError = true;
          }
        });
    }
  }

  ngOnDestroy() {
    this.$destroy.next();
    this.$destroy.complete();
  }
  
}
